import { Inject, Injectable } from "@angular/core";
import { GenericService } from "../services/generic.service";
import { environment } from "../environments/environment";
import { Observable } from "rxjs";
import { ServerResponse } from "../models/ServerResponse";
import { Entity, EntityExistenceAndPermissions } from "../models/Entity";
import { ElectricityMeter, GasMeter } from "../models/EnergyMeter";
import { ElectricityMeterConsumption, NaturalGasMeterConsumption } from "../models/EnergyConsumptions";
import { ISAPI, ISPagination, MVListingConfigs, MVOrdering, MVPagination } from "../models/api";
import { FilterOperator, FilterOptionsType, SortDirection } from "../models/generic";
import { Environment, ENVIRONMENT } from "../environments/environment.token";

@Injectable({
    providedIn: 'root'
})
export class InvoiceProcessorDataService {

    countryCode = 'pt';

    constructor(private genericService: GenericService, @Inject(ENVIRONMENT) private env: Environment) {
        this.countryCode = localStorage.getItem('selectedSIGA') ?? 'pt';
    }

    getElectricityMeterByCode(electricityMeterCode: string, apiUrl: string): Observable<ServerResponse<ElectricityMeter>> {
        return this.genericService.get(`${apiUrl}/ElectricityMeters/${this.countryCode}/ByCode/${electricityMeterCode}`, false);
    }

    getElectricityMeterConsumptions(electricityMeterId: number, dateFrom: string, dateTo: string, apiUrl: string): Observable<ServerResponse<ElectricityMeterConsumption[]>> {
        return this.genericService.get(`${apiUrl}/ElectricityMeters/${this.countryCode}/${electricityMeterId}/Consumptions/${dateFrom}/${dateTo}`, false);
    }

    getNaturalGasMeterByCode(naturalGasMeterCode: string, apiUrl: string): Observable<ServerResponse<GasMeter>> {
        return this.genericService.get(`${apiUrl}/NaturalGasMeters/${this.countryCode}/ByCode/${naturalGasMeterCode}`, false);
    }

    getNaturalGasMeterConsumptions(naturalGasMeterId: number, dateFrom: string, dateTo: string, apiUrl: string): Observable<ServerResponse<NaturalGasMeterConsumption[]>> {
        return this.genericService.get(`${apiUrl}/NaturalGasMeters/${this.countryCode}/${naturalGasMeterId}/Consumptions/${dateFrom}/${dateTo}`, false);
    }

    getSuppliers(supplierName?: string, body?: MVListingConfigs, callLoader: boolean = false): Observable<ServerResponse<any>> {
        if (!body) {
            body = new MVListingConfigs([], null, new MVPagination(1, 999));
            if (!String.isNullOrUndefinedOrWhitespace(supplierName)) {
                body.filters.push(
                    {
                        columnIdentifier: 'Name',
                        operator: FilterOperator.contains,
                        value: supplierName,
                        dataType: FilterOptionsType.text
                    }
                );
            }
        }

        return this.genericService.post(this.env.apiUrl + `/Suppliers/${this.countryCode}/Get`, body, undefined, callLoader);
    }

    getEntity(id: string, callLoader: boolean = false, apiUrl: string): Observable<ServerResponse<Entity>> {
        return this.genericService.get<Entity>(`${apiUrl}/Entities/${this.countryCode}/${id}`, callLoader);
    }

    getEntityByTin(tin: string, callLoader: boolean = false, apiUrl: string): Observable<ServerResponse<EntityExistenceAndPermissions>> {
        return this.genericService.get<EntityExistenceAndPermissions>(`${apiUrl}/Entities/${this.countryCode}/TIN/${tin}/CheckExistenceAndPermissions`, callLoader);
    }
}